import React, { useEffect } from "react";
import {
  IoCheckmarkCircle,
  IoAlertCircle,
  IoWarning,
  IoInformationCircle,
} from "react-icons/io5";

export default function AlertModal({
  visible,
  onClose,
  title,
  message,
  type = "success", // 'success' | 'error' | 'warning' | 'info'
  buttonText = "Geri Dön",
}) {
  // ESC tuşu basıldığında modalı kapatma
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && visible) {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [visible, onClose]);

  // Modal kapalıysa DOM'a hiçbir şey render etme
  if (!visible) return null;

  // Tipine göre ikon ve renk yapılandırması (React Native ile aynı Tailwind sınıfları)
  const getModalTheme = () => {
    switch (type) {
      case "success":
        return {
          bg: "bg-blue-100",
          icon: <IoCheckmarkCircle className="text-4xl text-[#1e3a8a]" />,
        };
      case "error":
        return {
          bg: "bg-red-100",
          icon: <IoAlertCircle className="text-4xl text-[#DC2626]" />,
        };
      case "warning":
        return {
          bg: "bg-amber-100",
          icon: <IoWarning className="text-4xl text-[#D97706]" />,
        };
      case "info":
      default:
        return {
          bg: "bg-sky-100",
          icon: <IoInformationCircle className="text-4xl text-[#0284C7]" />,
        };
    }
  };

  const theme = getModalTheme();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Arka Plan (Backdrop) - Dışarı tıklandığında kapanması için */}
      <div
        className="fixed inset-0 bg-black/50 transition-opacity animate-fadeIn"
        onClick={onClose}
      />

      {/* Modal Kartı */}
      <div className="relative w-full max-w-sm bg-white rounded-2xl p-6 flex flex-col items-center shadow-xl z-10 transition-all animate-scaleIn">
        {/* İkon Rozeti */}
        <div
          className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 ${theme.bg}`}
        >
          {theme.icon}
        </div>

        {/* Başlık */}
        {title && (
          <h3 className="text-xl font-bold text-gray-800 text-center mb-2">
            {title}
          </h3>
        )}

        {/* Mesaj */}
        {message && (
          <p className="text-base text-gray-600 text-center mb-6 leading-relaxed">
            {message}
          </p>
        )}

        {/* Kapat/Aksiyon Butonu */}
        <button
          type="button"
          onClick={onClose}
          className="w-full bg-[#1e3a8a] hover:bg-blue-900 active:scale-[0.98] text-white text-base font-semibold py-3 rounded-xl transition-all cursor-pointer shadow-md"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}
